import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import type { EditorState } from "./types";
import {
  getEditorMessagesAction,
  postMessageWithResponsesAction,
  uploadFileToEditorDialogAction,
} from "./actions";

export function postMessageWithResponsesReducerBuilder(
  builder: ActionReducerMapBuilder<EditorState>,
) {
  builder.addCase(postMessageWithResponsesAction.pending, (state, action) => {
    state.isMessageLoading = true;
  });
  builder.addCase(postMessageWithResponsesAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.messages = action.payload;
    state.isMessageLoading = false;
  });
  builder.addCase(postMessageWithResponsesAction.rejected, (state, action) => {
    state.isMessageLoading = false;
  });
}

export function getEditorMessagesReducerBuilder(
  builder: ActionReducerMapBuilder<EditorState>,
) {
  builder.addCase(getEditorMessagesAction.pending, (state, action) => {
    state.isMessageLoading = true;
  });
  builder.addCase(getEditorMessagesAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.messages = action.payload;
    state.isMessageLoading = false;
  });
  builder.addCase(getEditorMessagesAction.rejected, (state, action) => {
    state.isMessageLoading = false;
  });
}

export function uploadFileToEditorDialogReducerBuilder(
  builder: ActionReducerMapBuilder<EditorState>,
) {
  builder.addCase(uploadFileToEditorDialogAction.pending, (state, action) => {
    state.isFileLoading = true;
  });
  builder.addCase(uploadFileToEditorDialogAction.fulfilled, (state, action) => {
    state.isFileLoading = false;
  });
  builder.addCase(uploadFileToEditorDialogAction.rejected, (state, action) => {
    state.isFileLoading = false;
  });
}
